import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import {
  apiURL,
  formatDate,
  archiveUrl,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalOrderConfirmationMailer = ({
  customerNumber,
  archiveObject,
  setModalOrderConfirmationMailerState,
}) => {
  const { t } = useTranslation()

  const [InputData, setInputData] = useState({
    customer_number: customerNumber,
    archive_object: archiveObject,
    email_to: '',
    email_from: '',
    email_copy_to_sender: '',
    email_body: '',
  })

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const [Fdata, setFdata] = useState(false)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )
  const FormSubmit = (e) => {
    e.preventDefault()

    const data = new FormData()
    data.append(
      'order_confirmation_mailer[customer_number]',
      InputData.customer_number
    )
    data.append(
      'order_confirmation_mailer[archive_object]',
      InputData.archive_object
    )
    data.append('order_confirmation_mailer[email_to]', InputData.email_to)
    data.append('order_confirmation_mailer[email_from]', InputData.email_from)
    data.append(
      'order_confirmation_mailer[email_copy_to_sender]',
      InputData.email_copy_to_sender
    )
    data.append('order_confirmation_mailer[email_body]', InputData.email_body)

    setFdata(data)
    setPartnerPortalUrl(apiURL('order_confirmation_mailer'))

    setModalOrderConfirmationMailerState(false)
    return true
  }

  return (
    <div data-spa-type="order_confirmation_mailer">
      <form>
        <div className="mb-1 required">
          <label htmlFor="email_to">
            * {t('generic.spa.order_confirmation_mailer.email_to')}
          </label>
          <input
            type="text"
            className="form-control"
            name="email_to"
            required
            onChange={(e) =>
              setInputData({
                ...InputData,
                email_to: e.target.value,
              })
            }
          />
          <small className="form-text text-muted">
            {t('generic.spa.order_confirmation_mailer.email_to_helptext')}
          </small>
        </div>

        <div className="mb-1 required">
          <label htmlFor="email_from">
            * {t('generic.spa.order_confirmation_mailer.email_from')}
          </label>
          <input
            type="text"
            className="form-control"
            name="email_from"
            defaultValue="b2b@koenig-neurath.de"
            required
            onChange={(e) =>
              setInputData({
                ...InputData,
                email_from: e.target.value,
              })
            }
          />
        </div>

        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            name="email_copy_to_sender"
            onChange={(e) =>
              setInputData({
                ...InputData,
                email_copy_to_sender: e.target.value,
              })
            }
          />
          <label className="form-check-label" htmlFor="email_copy_to_sender">
            {t('generic.spa.order_confirmation_mailer.email_copy_to_sender')}
          </label>
        </div>

        <div className="mb-1 mt-1 required">
          <label htmlFor="email_body">
            * {t('generic.spa.order_confirmation_mailer.email_body')}
          </label>
          <textarea
            className="form-control"
            name="email_body"
            rows="5"
            onChange={(e) =>
              setInputData({
                ...InputData,
                email_body: e.target.value,
              })
            }
          ></textarea>
        </div>

        <div className="mb-1 pull-right">
          <button
            className="btn btn-primary btn-sm"
            type="submit"
            onClick={(e) => FormSubmit(e)}
          >
            {t('generic.spa.send')}
          </button>
        </div>
      </form>
    </div>
  )
}

export default ModalOrderConfirmationMailer
